import { cloneElement, FC, ReactElement, useState } from 'react'
import { ButtonProps } from 'src/types/bulma'

/**
 * Wraps the bulma button provided as child and hacks the onClick handler for double confirm
 */
export const ConfirmButton: FC<{
  children: ReactElement<{ onClick: any; 'data-tooltip'?: string } & ButtonProps>
}> = ({ children }) => {
  const [isFirstClick, setIsFirstClick] = useState(true)

  if (isFirstClick) {
    return cloneElement(children, { onClick: () => setIsFirstClick(false) })
  }
  return cloneElement(children, {
    color: 'danger',
    outlined: false,
    'data-tooltip': "Cliquez à nouveau pour confirmer l'action",
  })
}
